
import { mapGetters, mapMutations } from 'vuex';
import vClickOutside from 'v-click-outside';
import CatalogMenu from '@/components/header/Tertiary/CatalogMenu.vue';

export default {
    components: {
        CatalogMenu
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        ...mapGetters({
            getStateCatalog: 'getStateCatalog',
            categoryMenu: 'getMenu'
        })
    },
    methods: {
        ...mapMutations({
            setStateCatalog: 'setStateCatalog'
        })
    }
};
